import { HttpContext, HttpContextToken } from '@angular/common/http';

export const CUSTOM_ERROR_HANDLING = new HttpContextToken<string>(
  () => 'default',
);

// Lets a caller override the generic "no response" toast message for its own requests.
export const OVERRIDE_ERROR_MESSAGE = new HttpContextToken<string | null>(
  () => null,
);

// Creates a new HttpContext with the OVERRIDE_ERROR_MESSAGE set to the provided errorMessage.
export const createHttpErrorContext = (errorMessage: string | null) =>
  new HttpContext().set(OVERRIDE_ERROR_MESSAGE, errorMessage);

// Questionnaire save-response requests use this same context helper so the
// interceptor can show the domain-specific retry message instead of the generic one.
export const QUESTIONNAIRE_SAVE_RESPONSE_ERROR_MESSAGE =
  "We couldn't save your response. Please try again. If the problem continues, contact your administrator.";

export const questionnaireSaveResponseErrorContext = () =>
  createHttpErrorContext(QUESTIONNAIRE_SAVE_RESPONSE_ERROR_MESSAGE);

// Document upload requests use the same pattern for a domain-specific retry message.
export const DOCUMENT_UPLOAD_NO_RESPONSE_MESSAGE =
  "We couldn't upload your document. Please try again. If the problem continues, contact your administrator.";

export const uploadDocumentResponseErrorContext = () =>
  createHttpErrorContext(DOCUMENT_UPLOAD_NO_RESPONSE_MESSAGE);
